import styled from 'styled-components';

const StyledDevelopers = styled.div`
  overflow-x: hidden;
  width: 100%;
  .blogs{
    padding: 60px 0;
    padding-bottom: 120px;
  }
`;

export default StyledDevelopers;
